import React from 'react';

import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';

import { Card } from './Card';
import {
  CardContainer,
  HeaderContainer,
  HelpPanelContainer,
  IconWrapper,
} from './HelpPanel.styled';
import { HelpPanelCard } from './HelpPanelCard';

export interface HelpPanelViewProps {
  header: string;
  onClose?: () => void;
  cards: Card[];
  onLinkOpen: (link: string) => void;
  onExpand: (index: number) => void;
  onCollapse: () => void;
  openedIndex: number;
}

export const HelpPanelView: React.FC<HelpPanelViewProps> = ({
  header,
  onClose,
  cards,
  onLinkOpen,
  onExpand,
  onCollapse,
  openedIndex,
}: HelpPanelViewProps) => {
  return (
    <HelpPanelContainer>
      <HeaderContainer>
        <h4>{header}</h4>
        <IconWrapper onClick={onClose}>
          <EditorCloseIcon label='close' />
        </IconWrapper>
      </HeaderContainer>
      <CardContainer>
        {cards.map((card, index) => {
          return (
            <HelpPanelCard
              key={card.name}
              name={card.name}
              content={card.content}
              mainAction={card.mainAction}
              secondaryAction={card.secondaryAction}
              onLinkOpen={onLinkOpen}
              onExpand={() => onExpand(index)}
              onCollapse={onCollapse}
              isOpen={openedIndex === index}
            />
          );
        })}
      </CardContainer>
    </HelpPanelContainer>
  );
};
